// src/components/FolderManager.jsx
import React, { useState, useEffect, useRef } from 'react';
import EmojiPicker from '../shared/EmojiPicker';
import './FolderManager.css';

const FolderManager = ({ onFoldersUpdate }) => {
  const [folders, setFolders] = useState(() => {
    const stored = localStorage.getItem('messageFolders');
    return stored ? JSON.parse(stored) : [];
  });

  const [newFolderName, setNewFolderName] = useState('');
  const [newFolderEmoji, setNewFolderEmoji] = useState('🙂');
  const [newFolderColor, setNewFolderColor] = useState('#6b7280');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);

  const emojiTriggerRef = useRef(null); // ✅ ref for positioning picker

  useEffect(() => {
    localStorage.setItem('messageFolders', JSON.stringify(folders));
    if (onFoldersUpdate) onFoldersUpdate(folders);
  }, [folders, onFoldersUpdate]);

  const handleAdd = () => {
    const name = newFolderName.trim();
    if (!name) return;

    if (!folders.some(f => f.name === name)) {
      setFolders([...folders, { name, icon: newFolderEmoji, color: newFolderColor }]);
      resetInput();
    }
  };

  const handleEdit = (index) => {
    const folder = folders[index];
    setNewFolderName(folder.name);
    setNewFolderEmoji(folder.icon);
    setNewFolderColor(folder.color);
    setEditingIndex(index);
  };

  const handleSaveEdit = () => {
    const name = newFolderName.trim();
    if (name) {
      const updated = [...folders];
      updated[editingIndex] = { name, icon: newFolderEmoji, color: newFolderColor };
      setFolders(updated);
      resetInput();
    }
  };

  const handleDelete = (index) => {
    if (window.confirm(`Delete folder "${folders[index].name}"?`)) {
      setFolders(folders.filter((_, i) => i !== index));
    }
  };

  const resetInput = () => {
    setNewFolderName('');
    setNewFolderEmoji('🙂');
    setNewFolderColor('#6b7280');
    setEditingIndex(null);
  };

  return (
    <div className="folder-manager">
      <h3>📁 Folder Manager</h3>

      <div className="folder-input">
        <input
          type="text"
          value={newFolderName}
          placeholder="Folder name"
          onChange={(e) => setNewFolderName(e.target.value)}
        />

        <input
          type="color"
          value={newFolderColor}
          onChange={(e) => setNewFolderColor(e.target.value)}
          title="Pick folder color"
        />

        <span
          ref={emojiTriggerRef} // ✅ pass ref to your CustomEmojiPicker
          className="emoji-trigger"
          tabIndex={0}
          onClick={() => setShowEmojiPicker(prev => !prev)}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setShowEmojiPicker(prev => !prev)}
        >
          {newFolderEmoji}
        </span>

{showEmojiPicker && (
  <EmojiPicker
    lazyLoadEmojis
    skinTonesDisabled
    onEmojiClick={(emojiData) => {
      setNewFolderEmoji(emojiData.emoji);
      setShowEmojiPicker(false);
    }}
  />
)}

        {editingIndex !== null ? (
          <button onClick={handleSaveEdit}>💾 Save</button>
        ) : (
          <button onClick={handleAdd}>➕ Add</button>
        )}
      </div>

      <ul className="folder-list">
        {folders.map((folder, index) => (
          <li key={index}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span className="folder-color-badge" style={{ backgroundColor: folder.color }} />
              <span>{folder.icon}</span>
              <span>{folder.name}</span>
            </span>
            <div>
              <button onClick={() => handleEdit(index)}>✏️ Edit</button>
              <button onClick={() => handleDelete(index)}>🗑️ Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FolderManager;
